import React from "react";
import PropTypes from "prop-types";
import APIMaintenance from "../APIMaintenance";

const DiseaseFundMaintenance = ({
  title,
  maintenanceMessageLine1,
  maintenanceMessageLine2,
}) => {
  return (
    <div className="Page-banner hasCard">
      <div className="Page-banner-titleContainer">
        <h1 className="Page-banner-pageTitle f-pageTitle-sans u-mb1">
          {title}
        </h1>
      </div>

      <div className="Page-banner-card">
        <div className="Card bg-coral-light-50">
          <div className="Card-inner">
            <div className="Card-inner-content">
              <div className="u-mt2 u-mb2">
                <APIMaintenance
                  line1={maintenanceMessageLine1}
                  line2={maintenanceMessageLine2}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DiseaseFundMaintenance.propTypes = {
  title: PropTypes.string.isRequired,
};

export default DiseaseFundMaintenance;
